import React from "react";
import { Helmet } from "react-helmet";

import { JSONLDComponent } from "../JSONLDComponent";

import { JobPostingJson } from "./types";
import { buildStructuredData } from "./utils";

import { helmetTitle } from "~/utils";

export const JobPostingSchema: React.FC<{
  jobPostingJson: JobPostingJson;
}> = ({ jobPostingJson }) => (
  <React.Fragment>
    <Helmet>
      <link rel="canonical" href={jobPostingJson.absolute_url} />
      <title>
        {helmetTitle([
          `Join EquipmentShare as a ${jobPostingJson.google.job.title}`,
        ])}
      </title>
    </Helmet>
    <JSONLDComponent structuredData={buildStructuredData(jobPostingJson)} />
  </React.Fragment>
);
